import React from 'react';
import { Switch, Route, useLocation, useRouteMatch, Redirect } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import getRouteKey from 'utilities/getRouteKey';
import joinPath from 'utilities/joinPath';
import Page from 'components/Page';
import Container from 'components/sidebar/Container';
import Content from 'components/sidebar/Content';
import PageContainer from 'components/PageContainer';
import PageTemplate from 'templates/PageTemplate';

import SubpageSidebar from './SubpageSidebar';


const SubpageRouter = ({ page }) => {
    const location = useLocation();
    const match = useRouteMatch();
    
    return (
        <Page>
            <Container>
                <SubpageSidebar page={page} />
                
                <Content>
                    <PageContainer>
                        <AnimatePresence>
                            <Switch location={location} key={getRouteKey(location, match)}>
                                {/* Redirect from parent page to first child */}
                                <Route exact path={match.path}>
                                    <Redirect to={joinPath(match.path, page.children[0].slug)} />
                                </Route>
                                
                                {/* Route for child pages */}
                                {page.children.map((childPage) => (
                                    <Route key={childPage.slug} path={joinPath(match.path, childPage.slug)}>
                                        <PageTemplate page={childPage}/>
                                    </Route>
                                ))}
                            </Switch>
                        </AnimatePresence>
                    </PageContainer>
                </Content>
            </Container>
        </Page>
    );
};


export default SubpageRouter;
